'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  return typeof window === 'undefined' || !!window.SSRtest;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-first-router/dist/pure-utils/isServer.js
// module id = 354
// module chunks = 0